class WebSocketService {
  constructor() {
    this.socket = null;
    this.url = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000;
    this.reconnectTimeout = null;
    this.messageListeners = [];
    this.shouldReconnect = true;
  }

  connect(url) {
    if (this.socket) {
      console.warn("⚠ Closing previous WebSocket connection before opening a new one.");
      this.disconnect();
    }

    this.url = url;
    this.shouldReconnect = true;
    console.log("🚀 Connecting to WebSocket:", url);
    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      this.reconnectAttempts = 0;
      console.log("✅ WebSocket Connected:", url);
    };

    this.socket.onerror = (error) => {
      console.error("🚨 WebSocket Connection Error:", error);
    };

    this.socket.onclose = () => {
      this.socket = null;
      if (this.shouldReconnect) {
        this.attemptReconnect();
      } else {
        console.log("🛑 WebSocket closed intentionally. No reconnection.");
      }
    };

    this.socket.onmessage = (event) => {
      console.log("📩 New Message Received:", event.data);

      // Check for binary data
      if (event.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          this.notifyListeners(reader.result);
        };
        reader.readAsText(event.data);
      } else {
        this.notifyListeners(event.data);
      }
    };
  }

  disconnect() {
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
    }

    if (this.socket) {
      this.shouldReconnect = false;
      this.socket.onclose = null;
      this.socket.close();
      this.socket = null;
      console.log("🔌 WebSocket Disconnected");
    }
  }

  onMessage(callback) {
    if (!this.messageListeners.includes(callback)) {
      this.messageListeners.push(callback);
    }
  }

  removeMessageListener(callback) {
    this.messageListeners = this.messageListeners.filter((cb) => cb !== callback);
  }

  notifyListeners(data) {
    this.messageListeners.forEach((callback) => callback(data));
  }

  attemptReconnect() {
    if (!this.shouldReconnect || this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.warn("❌ Max reconnect attempts reached. Stopping.");
      return;
    }

    let delay = Math.min(this.reconnectDelay * Math.pow(2, this.reconnectAttempts), 10000);

    this.reconnectTimeout = setTimeout(() => {
      this.reconnectAttempts++;
      console.log(`🔄 Reconnecting... Attempt ${this.reconnectAttempts}`);
      this.connect(this.url);
    }, delay);
  }

  sendMessage(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
      console.log("📤 Message Sent:", message);
    } else {
      console.warn("⚠ WebSocket is not connected! Cannot send message.");
    }
  }
}

export default new WebSocketService();
